import { render } from "./user-layout2.vue?vue&type=template&id=e90fb3b4&scoped=true&ts=true"
import script from "./user-layout2.vue?vue&type=script&lang=ts"
export * from "./user-layout2.vue?vue&type=script&lang=ts"

import "./user-layout2.vue?vue&type=style&index=0&id=e90fb3b4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90fb3b4"]])

export default __exports__